import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { MentionCollection } from '../index'

export const setupMentionReplication = (
  collection: MentionCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'mentions',
    displayName: 'Mention',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      userId: doc.userId,
      sourceType: doc.sourceType ?? null,
      sourceId: doc.sourceId ?? null,
      isRead: doc.isRead || false,
      readAt: doc.readAt ? (toTimestamp(doc.readAt) ?? new Date(doc.readAt).getTime()) : null,
      isDeleted: doc.isDeleted || false,
      userName: doc.userName,
      userEmail: doc.userEmail,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      entityType: state.entityType,
      entityId: state.entityId,
      userId: state.userId,
      sourceType: state.sourceType ?? null,
      sourceId: state.sourceId ?? null,
      isRead: state.isRead,
      readAt: toISOStringOrNull(state.readAt),
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
